module.exports = __webpack_public_path__ + "static/media/16.53e4bb8e.jpg";